import { useEffect } from "react";
import { DocumentsContainer } from "../components/documents/DocumentsContainer";
import { Header } from "../components/Header";
import { useAnalytics } from "../lib/analytics";
import styles from "./Documents.module.css";

export function Documents() {
	const { logEvent } = useAnalytics();

	// Track page view
	useEffect(() => {
		logEvent("documents_page_viewed");
	}, [logEvent]);

	return (
		<div className={styles.wrapper}>
			<Header />
			<main className={styles.main}>
				<DocumentsContainer />
			</main>
		</div>
	);
}
